<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal'

const props = defineProps<{
  url: string
}>()

const emit = defineEmits<{
  (e: 'confirm'): void
}>()

const { popout, setBonusPointsWhenRegistering } = usePopoutStore()
</script>

<template>
  <VueFinalModal
    v-if="popout"
    class="confirm-modal"
    content-class="confirm-modal-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <ButtonClose
      class="close"
      @click="emit('confirm')"
    />
    <div class="content">
      <img
        v-if="popout.mobile_image"
        :src="popout.mobile_image.url"
        alt="visuel"
        class="mobile"
      />
      <img
        v-if="popout.desktop_image"
        :src="popout.desktop_image.url"
        alt="visuel"
        class="desktop"
      />
      <h1>{{ popout.bo_title }}</h1>
      <h2>{{ popout.sur_title }}</h2>
      <p>{{ popout.content }}</p>
      <div class="buttons">
        <ButtonSimple
          v-if="popout.popin_ctas[0]"
          :route="props.url"
          :label="popout.popin_ctas[0].wording_button"
          target="_blank"
        />

        <ButtonSimple
          v-if="popout.popin_ctas[1]"
          :route="popout.popin_ctas[1].url_button"
          :label="popout.popin_ctas[1].wording_button"
          color="white"
          @click="setBonusPointsWhenRegistering(true)"
        />
      </div>
    </div>
  </VueFinalModal>
</template>

<style>
.confirm-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.confirm-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 570px;
  max-height: 90dvh;
  background-image: url('/assets/img/step2bg.jpg');
  background-position: cover;
  background-position: center;

  @media (min-width: 1024px) {
    max-width: 900px;
  }

  .close {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    height: 100%;
    overflow-y: auto;
    padding: 2rem;
    color: white;
    text-align: center;

    @media (min-width: 500px) {
      padding: 2rem 4rem;
    }

    @media (min-width: 1024px) {
      gap: 2rem;
      padding: 4rem;
    }

    h1,
    h2 {
      line-height: 1.3;
      letter-spacing: 0;
    }

    h1 {
      font-size: 2.5rem;

      @media (min-width: 1024px) {
        font-size: 3rem;
      }
    }

    h2 {
      font-size: 1.5rem;

      @media (min-width: 1024px) {
        font-size: 2rem;
      }
    }

    p {
      font-size: 1.3rem;
      line-height: 1.3;

      @media (min-width: 1024px) {
        font-size: 1.5rem;
        line-height: 1.4;
      }
    }

    img {
      &.mobile {
        width: 100%;
        height: auto;

        @media (min-width: 1024px) {
          display: none;
        }
      }

      &.desktop {
        display: none;

        @media (min-width: 1024px) {
          display: block;
          width: 400px;
        }
      }
    }

    .buttons {
      width: fit-content;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      @media (min-width: 1024px) {
        flex-direction: row;
        gap: 2rem;
      }
    }
  }
}
</style>
